/**
 * Initialize animation observers for jumbo-text-container elements
 * Animates text and images when container is 50% in view
 */
// Store observers so we can disconnect them when re-initializing
const jumboTextObservers = new WeakMap()

function initJumboTextAnimations() {
  const containers = document.querySelectorAll('.jumbo-text-container')

  containers.forEach((container) => {
    // Disconnect existing observer if one exists
    const existingObserver = jumboTextObservers.get(container)
    if (existingObserver) {
      existingObserver.disconnect()
      jumboTextObservers.delete(container)
    }

    // Remove animate-in class to allow re-animation in theme editor
    container.classList.remove('animate-in')

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            container.classList.add('animate-in')
            // Disconnect after triggering once
            observer.disconnect()
            jumboTextObservers.delete(container)
          }
        })
      },
      {
        threshold: 0.5,
      }
    )

    jumboTextObservers.set(container, observer)
    observer.observe(container)
  })
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initJumboTextAnimations)
} else {
  initJumboTextAnimations()
}

// Re-initialize for dynamically added content
if (typeof window !== 'undefined') {
  window.initJumboTextAnimations = initJumboTextAnimations
}

// Re-initialize when sections are loaded/reloaded in theme editor
document.addEventListener('shopify:section:load', () => {
  // Use a small delay to ensure DOM is fully updated
  setTimeout(initJumboTextAnimations, 100)
})

// Also re-initialize on section reorder
document.addEventListener('shopify:section:reorder', () => {
  setTimeout(initJumboTextAnimations, 100)
})
